import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { Eye, EyeOff } from "lucide-react";
import logo from "../assets/img/logo.png";
import loginimg from "../assets/img/loginimg.png";
import api from "../api";

const resetPassword = ({ token, password, confirmPassword }) =>
  api(`/auth/reset-password/${token}`, { method: "POST", body: JSON.stringify({ password, confirmPassword }) });

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [matchError, setMatchError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const mutation = useMutation({
    mutationFn: resetPassword,
    onSuccess: () => navigate("/login"),
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    if (password !== confirm) { setMatchError("Passwords do not match"); return; }
    setMatchError("");
    mutation.mutate({ token, password, confirmPassword: confirm });
  };

  return (
    <div style={styles.wrapper}>
      <div style={styles.left}>
        <img src={logo} alt="logo" style={styles.logo} />
        <div style={styles.box}>
          <h2 style={styles.title}>Reset Password</h2>
          <p style={styles.sub}>Enter your new password below.</p>

          {mutation.isError && <div style={styles.error}>{mutation.error.message}</div>}
          {matchError && <div style={styles.error}>{matchError}</div>}

          <form onSubmit={handleSubmit} style={styles.form}>
            <div style={styles.fieldGroup}>
              <label style={styles.label}>New Password</label>
              <div style={styles.inputWrap}>
                <input style={styles.input} type={showPassword ? "text" : "password"} placeholder="Enter new password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                <span style={styles.eyeIcon} onClick={() => setShowPassword(!showPassword)}>
                  {showPassword ? <Eye size={16} /> : <EyeOff size={16} />}
                </span>
              </div>
            </div>
            <div style={styles.fieldGroup}>
              <label style={styles.label}>Confirm Password</label>
              <div style={styles.inputWrap}>
                <input style={styles.input} type={showConfirm ? "text" : "password"} placeholder="Confirm new password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required />
                <span style={styles.eyeIcon} onClick={() => setShowConfirm(!showConfirm)}>
                  {showConfirm ? <Eye size={16} /> : <EyeOff size={16} />}
                </span>
              </div>
            </div>
            <button style={styles.btn} type="submit" disabled={mutation.isPending}>
              {mutation.isPending ? "Resetting..." : "Reset Password"}
            </button>
          </form>
        </div>
      </div>
      <div style={styles.right}>
        <img src={loginimg} alt="visual" style={styles.loginImg} />
      </div>
    </div>
  );
}

const styles = {
  wrapper: { display: "flex", height: "100vh", fontFamily: "'Segoe UI', sans-serif", overflow: "hidden" },
  left: { flex: 1, background: "#fff", display: "flex", flexDirection: "column", padding: "40px 60px", paddingLeft: "150px", justifyContent: "center", marginLeft: 80 },
  logo: { width: 140, objectFit: "contain", marginBottom: 40, marginLeft: 80 },
  box: { maxWidth: 400 },
  title: { fontSize: 24, fontWeight: 700, color: "#0ea5e9", marginBottom: 6 },
  sub: { fontSize: 14, color: "#64748b", marginBottom: 24 },
  form: { display: "flex", flexDirection: "column", gap: 16 },
  fieldGroup: { display: "flex", flexDirection: "column", gap: 6 },
  label: { fontSize: 13, fontWeight: 600, color: "#1e293b" },
  input: { padding: "10px 14px", borderRadius: 8, border: "1px solid #e2e8f0", fontSize: 14, outline: "none", width: "100%", boxSizing: "border-box" },
  inputWrap: { position: "relative", display: "flex", alignItems: "center" },
  eyeIcon: { position: "absolute", right: 12, cursor: "pointer", color: "#94a3b8", display: "flex" },
  btn: { padding: "11px", background: "#0ea5e9", color: "#fff", border: "none", borderRadius: 8, fontSize: 15, fontWeight: 600, cursor: "pointer", marginTop: 4 },
  error: { background: "#fee2e2", color: "#dc2626", padding: "8px 12px", borderRadius: 6, fontSize: 13, marginBottom: 12 },
  right: { flex: 1, background: "#fff", display: "flex", alignItems: "center", justifyContent: "flex-end", overflow: "hidden", paddingRight: 30 },
  loginImg: { width: "110%", height: "95%", objectFit: "cover", borderRadius: "15px" },
};
